export default () => {
  $(".switch-language").addClass($(".current-lang a").attr("lang"));
  $(document).on("click", ".switch-language .current-lang a", function (e) {
    e.preventDefault();
    $(this).toggleClass("open");
    $(".switch-language li:not(.current-lang)").toggle("fast");
  });
};
